<template>
  <div>
    <v-container v-show="isWelcome">
      <v-layout row class="pt-4">
        <v-flex sm12>
          <p class="subheading">Votre liste de pointage direct est vide.<br />
          Voulez-vous <a @click.prevent="addDirectScoring()">pointer un électeur</a> ?</p>
        </v-flex>
      </v-layout>
    </v-container>
    <v-list three-line class="pa-0" v-show="directScorings.length > 0">
      <v-subheader>Liste des électeurs pointés directement</v-subheader>
      <template v-for="(directScoring, index) in directScorings">
        <v-list-tile
          :key="index"
          avatar
          ripple
          :class="{ grey : isOdd(index), 'lighten-5' : isOdd(index) }"
          @click="directScoring = directScoring"
        >
          <v-list-tile-content @click="editDirectScoring(directScoring)">
            <v-list-tile-title>{{ directScoring.last_name }}, {{ directScoring.first_name }}</v-list-tile-title>
            <v-list-tile-sub-title>
              <span>{{ directScoring.district ? directScoring.district.name : '' }}</span>
              <span v-show="directScoring.postal_code && directScoring.postal_code !== ''"> &bull; </span>
              <span v-show="directScoring.postal_code">{{ directScoring.postal_code }}</span>
              <span v-show="directScoring.email"> &bull; </span>
              <span v-show="directScoring.email">{{ directScoring.email }}</span>
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-avatar
            :color="directScoring.score.background || 'grey lighten-1'"
            class="mt-1 white--text"
            @click="editDirectScoring(directScoring)"
          >
            {{ directScoring.score.code }}
          </v-list-tile-avatar>
          <v-list-tile-action>
              <v-menu
                transition="slide-y-transition"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon dark>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    @click="editDirectScoring(directScoring)"
                  >
                    <v-list-tile-title class="body-1">Modifier le pointage électeur</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    @click="removeDirectScoring(directScoring)"
                  >
                    <v-list-tile-title class="body-1">Enlever de la liste</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider
          :key="index + '-divider'"
        ></v-divider>
      </template>
    </v-list>
    <v-btn
      fixed
      fab
      top
      right
      class="mt-2 btn-add-direct-scoring"
      @click="addDirectScoring()"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="directScoringDialog" ref="directScoringDialog" persistent max-width="95%">
      <v-card>
        <v-card-title>
          <span class="title">{{ selectedDirectScoring._local_id ? 'Modifier un pointage électeur' : 'Ajouter un pointage électeur' }}</span>
        </v-card-title>
        <v-card-text class="pt-0">
        <v-form
          ref="directScoringForm"
          v-model="selectedDirectScoringValid"
        >
          <v-container grid-list-md class="pt-0">
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Nom de famille*"
                  v-model="selectedDirectScoring.last_name"
                  required
                  :rules="lastNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Prénom*"
                  v-model="selectedDirectScoring.first_name"
                  required
                  :rules="firstNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  ref="selectedDirectScoringDistrict"
                  :items="districtChoices"
                  item-text="name"
                  item-value="district_id"
                  return-object

                  label="Circonscription"
                  v-model="selectedDirectScoring.district"
                  required
                >
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6>
            <v-menu
              ref="directScoringDialogBirthDateMenu"
              v-model="directScoringDialogBirthDateMenu"
              :close-on-content-click="false"
              :nudge-right="60"
              lazy
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formattedSelectedDirectScoringBirthDate"
                  label="Date de naissance"
                  prepend-icon="event"
                  clearable
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                @change="saveDirectScoringDialogBirthDateMenu"
                ref="directScoringDialogBirthDatePicker"
                :locale="locale"
                v-model="selectedDirectScoring.birth_date"
                :max="directScoringMaxDate"
                min="1900-01-01"
                :title-date-format="formatBirthDay"
                :landscape="landscape"
                fixed
              >
                <v-spacer></v-spacer>
                  <v-btn
                    @click="directScoringDialogBirthDateMenu = false"
                    flat
                    outline
                    color="primary"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    @click="$refs.directScoringDialogBirthDateMenu.save(selectedDirectScoring.birth_date)"
                    color="primary"
                  >
                    OK
                  </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Code postal"
              v-model="selectedDirectScoring.postal_code"
              validate-on-blur
              mask="A#A #A#"
              :rules="postalCodeRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Numéro civique"
              v-model="selectedDirectScoring.civic_number"
              validate-on-blur
              :rules="civicNumberCodeRules"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="Adresse courriel"
              v-model="selectedDirectScoring.email"
              validate-on-blur
              :rules="emailRules"
              type="email"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              label="SMS"
              v-model="selectedDirectScoring.phone_principal"
              validate-on-blur
              mask="phone"
              :rules="phoneRules"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              v-model="selectedDirectScoring.score"
              label="Pointage"
              solo
              required
              :items="scoreChoices"
              :rules="scoreRules"
              item-text="text"
              item-value="code"
              return-object
              :color="selectedDirectScoring.score ? selectedDirectScoring.score.background : 'white'"
              :background-color="selectedDirectScoring.score ? selectedDirectScoring.score.background : ''"
            >
              <template v-slot:selection="{ item, index }">
                <span class="flex" :class="item.color">{{ item.text }}</span>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.indentText"/>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-container>
      <small>* Indique les champs requis.</small>
    </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" flat @click="cancelSelectedDirectScoring()">Annuler</v-btn>
      <v-btn color="blue darken-1" flat @click="saveSelectedDirectScoring()">Enregistrer</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<v-snackbar
  v-model="snackbar"
  color="dark"
  :timeout="12000"
  class="ma-2"
  flat
>
  {{ snackbarMessage }}
  <v-btn
    flat
    color="primary lighten-2"
    class="text-none"
    @click="snackbarClickButton"
  >
    {{ snackbarButton }}
  </v-btn>
</v-snackbar>
</div>
</template>

<script>

import _ from 'lodash'
import { Auth } from '../auth'
import districts from '../data/districts'
import { Exchanger } from '../exchanger'
import moment from 'moment'
import 'moment/src/locale/fr-ca'
import { nSQL } from "@nano-sql/core"
import uuidv4 from 'uuid/v4'
import scores from '../data/scores'

const emailRegex = new RegExp(/.+@.+/);
const phoneRegex = new RegExp(/^\d{10}$/);
const postalCodeRegex = new RegExp(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i);

export default {

  data() {
    return {
      loaded: false,
      snackbar: false,
      snackbarMessage: 'Message',
      snackbarButton: 'Button',
      snackbarButtonClickCallback: function () {
      },
      landscape: false,
      locale: 'fr-ca',
      lastNameRules: [
        v => !!v || 'Le nom de famille est obligatoire',
        v => (v && v.length <= 128) || 'Le nom de famille ne doit pas contenir plus de 128 caractères'
      ],
      firstNameRules: [
        v => !!v || 'Le prénom est obligatoire',
        v => (v && v.length <= 128) || 'Le prénom ne doit pas contenir plus de 128 caractères'
      ],
      postalCodeRules: [
        v => (!v || postalCodeRegex.test(v)) || 'Le code postal n\'est pas valide'
      ],
      civicNumberCodeRules: [
        v => (!v || v.length <= 16) || 'Le numéro civique n\'est pas valide'
      ],
      emailRules: [
        v => (!v || emailRegex.test(v)) || 'L\'adresse courriel n\'est pas valide'
      ],
      phoneRules: [
        v => (!v || phoneRegex.test(v)) || 'Le numéro n\'est pas valide'
      ],
      scoreRules: [
        v => !!v || 'Le pointage est obligatoire',
        v => (v && -1 !== _.findIndex(this.scoreChoices, {code: v.code})) || 'Le pointage n\'est pas valide'
      ],
      selectedDirectScoring: {},
      selectedDirectScoringValid: true,
      defaultDirectScoring: {
        last_name: null,
        first_name: null,
        birth_date: null,
        postal_code: null,
        civic_number: null,
        district: null,
        score: null
      },
      directScoringDialog: false,
      directScoringDialogBirthDateMenu: false,
      directScorings: [],
      scoreChoices: _.filter(scores, {"political": true}),
      districtChoices: districts
    }
  },

  mounted() {
    this.defaultDirectScoring.district = {
      "district_id": 212,
      "name": "Saint-Jean"
    };

    this.selectedDirectScoring = Object.assign({}, this.defaultDirectScoring);

    this.refreshDirectScorings();
    this.refreshUser();

    Auth.$on('logged-in', function () {
      this.refreshUser();
    }.bind(this));

    Auth.$on('logged-out', function () {
      this.refreshUser();
    }.bind(this));
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  computed: {
    isWelcome() {
      return this.loaded && this.directScorings.length === 0;
    },

    directScoringMaxDate() {
      const now = new Date();

      now.year -= 15;

      return new Date().toISOString().substr(0, 10);
    },

    formattedSelectedDirectScoringBirthDate() {
      const momentLocale = moment.locale();

      moment.locale(this.locale);

      const returnValue = this.selectedDirectScoring.birth_date
        ? moment(this.selectedDirectScoring.birth_date, 'YYYY-MM-DD').format('LL') : '';

      moment.locale(momentLocale);

      return returnValue;
    },

    selectedDirectScoringMinBirthDate() {
      return new Date().toISOString().substr(0, 10);
    }
  },

  watch: {
    directScoringDialog(val) {
      !val && this.$vuetify.goTo(0, {container: this.$refs.directScoringDialog.$refs.dialog})
    },
    directScoringDialogBirthDateMenu(val) {
      val && setTimeout(() => (this.$refs.directScoringDialogBirthDatePicker.activePicker = 'YEAR'))
    }
  },

  methods: {
    refreshUser() {
      if (Auth.isAuthenticated()) {
        const defaultDistrictId = _.filter(Auth.user().district_ids, function (districtId) {
          return -1 === [0, 8888, 9999].indexOf(districtId);
        }.bind(this))[0] || null;

        if (defaultDistrictId) {
          this.defaultDirectScoring.district = _.find(this.districtChoices, {'district_id': defaultDistrictId});
        }
      } else {
        this.defaultDirectScoring.district = null;
      }
    },

    refreshDirectScorings: async function () {
      if (Auth.isAuthenticated()) {
        const directScoringRecords = await nSQL('direct_scorings')
          .query("select")
          .where(["user_id", "=", Auth.user().id])
          .where(["locally_deleted", "!=", true])
          .exec();

        this.directScorings = [];
        for (let i = 0, len = directScoringRecords.length; i < len; i++) {
          this.directScorings.push(this.toDirectScoring(directScoringRecords[i]));
        }
      } else {
        this.directScorings = [];
      }

      this.loaded = true;
    },

    toDirectScoringRecord(directScoring) {
      const directScoringRecord = Object.assign({}, directScoring, {
        district_id: directScoring.district.district_id,
        score: directScoring.score.code,
        user_id: Auth.user().id,
      });

      delete directScoringRecord.district;

      return directScoringRecord;
    },

    toDirectScoring(directScoringRecord) {
      const directScoring = Object.assign({}, directScoringRecord, {
        district: _.find(this.districtChoices, {'district_id': directScoringRecord.district_id}),
        score: _.find(this.scoreChoices, {'code': directScoringRecord.score}),
      });

      delete directScoring.district_id;

      return directScoring;
    },

    snackbarClickButton() {
      (this.snackbarButtonClickCallback)();

      this.snackbarButtonClickCallback = function () {
      };

      this.snackbar = false;
    },

    handleResize() {
      this.landscape = window.innerWidth > window.innerHeight;
    },

    formatBirthDay(val) {
      return this.formatBirthDate(val, 'D MMMM');
    },

    formatBirthDate(val, format) {
      const momentLocale = moment.locale();

      moment.locale(this.locale);

      const returnValue = val ? moment(val, 'YYYY-MM-DD').format(format || 'LL') : '';

      moment.locale(momentLocale);

      return returnValue;
    },

    setSnackbar(value, message, button, callback) {
      if (value !== null) {
        this.snackbar = value;
      }

      this.snackbarMessage = message;
      this.snackbarButton = button;
      this.snackbarButtonClickCallback = callback;
    },

    removeDirectScoring: async function (directScoring) {
      const directScoringRecord = this.toDirectScoringRecord(directScoring);

      directScoringRecord.locally_deleted = true;

      await nSQL('direct_scorings')
        .query("upsert", directScoringRecord)
        .exec();

      this.refreshDirectScorings();

      this.setSnackbar(true, '1 pointage supprimée', 'Annuler', async function () {
        directScoringRecord.locally_deleted = false;

        await nSQL('direct_scorings')
          .query("upsert", directScoringRecord)
          .exec();

        this.refreshDirectScorings();
      }.bind(this));
    },

    validateSelectedDirectScoring() {
      return this.$refs.directScoringForm.validate();
    },

    resetSelectedDirectScoringValidation() {
      this.$refs.directScoringForm.resetValidation();
    },

    cancelSelectedDirectScoring() {
      this.directScoringDialog = false;
    },

    saveSelectedDirectScoring: async function () {
      if (!this.validateSelectedDirectScoring() || !Auth.isAuthenticated()) {
        return;
      }

      const directScoringRecord = this.toDirectScoringRecord(this.selectedDirectScoring);

      let isNew = !directScoringRecord.local_id;
      let isDirty;

      if (isNew) {
        isDirty = true;
        directScoringRecord.local_id = uuidv4();
      } else {
        const freshDirectScoringRows = await nSQL('direct_scorings')
          .query('select')
          .where(['local_id', '=', directScoringRecord.local_id])
          .exec();

        isDirty = freshDirectScoringRows.length === 0
          ? true
          : !_.isEqual(directScoringRecord, freshDirectScoringRows[0]);
      }

      if (isDirty) {
        directScoringRecord.locally_updated_at = moment().valueOf();

        nSQL('direct_scorings')
          .query("upsert", directScoringRecord)
          .exec()
          .then(function () {
            this.refreshDirectScorings();

            Exchanger.pushDirectScorings();
          }.bind(this));
      }

      this.directScoringDialog = false;
    },

    isOdd: function (number) {
      return (number % 2) !== 0;
    },

    addDirectScoring: function () {
      this.selectedDirectScoring = Object.assign({}, this.defaultDirectScoring);
      this.resetSelectedDirectScoringValidation();
      this.directScoringDialog = true;
    },

    editDirectScoring: function (directScoring) {
      this.selectedDirectScoring = Object.assign({}, directScoring);
      this.resetSelectedDirectScoringValidation();
      this.directScoringDialog = true;
    },

    getNewDirectScoring: function () {
      return {
        last_name: null,
        first_name: null,
        birth_date: null,
        postal_code: null,
        civic_number: null,
        district: null,
      };
    },

    saveDirectScoringDialogBirthDateMenu(date) {
      this.$refs.directScoringDialogBirthDateMenu.save(date)
    }
  },
}

</script>

<style>
  .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 95%;
  }
  .v-dialog__content {
    padding: 2%; /* iOS 11.0 */
    padding: 2%; /* iOS 11.2 */
  }
  .v-snack__wrapper {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
  }
  .v-autocomplete.v-select.v-text-field input {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .btn-add-direct-scoring.v-btn--top:not(.v-btn--absolute) {
    top: 16px;
    top: calc(16px + constant(safe-area-inset-top)); /* iOS 11.0 */
    top: calc(16px + env(safe-area-inset-top)); /* iOS 11.2 */
  }
</style>
